import { SessionData } from "./session-context"
import { StepId } from "./step-registry"

export type BackAction = { type: "CLOSE_SHEET" } | { type: "NAVIGATE_TO_STEP"; stepId: StepId }

// Determine what back button should do based on current step and session state
export function resolveBackAction(currentStepId: StepId, sessionData: SessionData): BackAction {
  switch (currentStepId) {
    case StepId.PAYMENT_OPTIONS_PICKER:
      // First step - close the sheet
      return { type: "CLOSE_SHEET" }

    case StepId.SIGNUP_NATIVE:
      // Go back to payment options
      return { type: "NAVIGATE_TO_STEP", stepId: StepId.PAYMENT_OPTIONS_PICKER }

    case StepId.LOAN_OPTIONS:
      // Typically can't go back from loan options, but if needed:
      return { type: "CLOSE_SHEET" }

    case StepId.LOADING:
    case StepId.SUCCESS:
    case StepId.REJECTED:
    case StepId.SERVER_ERROR:
    case StepId.INSUFFICIENT_FUNDS:
      // Final states - close sheet
      return { type: "CLOSE_SHEET" }

    default:
      // Fallback - close sheet
      return { type: "CLOSE_SHEET" }
  }
}
